import { Component, OnInit } from '@angular/core';

import {
  DashboardData,
  DomainService,
  ErroMessages,
  IDomain,
  IErroMessages,
  ImagemService,
  TokenService
} from 'viggo-sistemas-core-web';

import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { catchError, map, mergeMap, of, throwError, timer } from 'rxjs';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DomainService, ImagemService]
})
export class DashboardComponent implements OnInit {
  // TODO: ALTERANDO AQUI ALTERA O CARD DE PRIMEIRO CONTATO
  infoFirstContact = {
    title: 'Me fala do seu negócio?',
    subtitle: `Vamos adicionar algumas informações sobre o seu negócio? clica
    na setinha!`,
    description: `As informações que serão adicionadas aqui servirão para nós e seus
            clientes sabermos um pouco mais sobre sua empresa e facilitar a
            identificação nas nossas bases`,
    url: ['dados-empresa/editar']
  };

  links = {
    config: '../dados-empresa/settings',
    edit: '../dados-empresa/editar'
  };
  public loading = true;
  public showError = false;
  errorObj = {
    title: 'Erro detectado',
    srcImg: './assets/images/access_denied.svg',
    classImg: 'content-img',
    message: 'Erro detectado'
  } as {
    title: string;
    srcImg: string;
    classImg: string;
    message: string;
  };
  dashboardDataTestes = [
    {
      title: 'Vendas',
      icon: 'pi pi-fw pi-shopping-cart',
      showPopUp: false,
      statistic_data: 640,
      statistic_result: '1420 realizadas',
      overviewChartData: {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September'
        ],
        datasets: [
          {
            data: [50, 64, 32, 24, 18, 27, 20, 36, 30],
            borderColor: ['#009688'],
            backgroundColor: ['#80CBC4'],
            borderWidth: 2,
            fill: true,
            tension: 0.4
          }
        ]
      },
      overviewChartOptions: {
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            display: false
          },
          x: {
            display: false
          }
        },
        tooltips: {
          enabled: false
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    },
    {
      title: 'Receita',
      icon: 'pi pi-fw pi-dollar',
      showPopUp: false,
      statistic_data: 57,
      statistic_result: 'R$ 9,640 nesse mês',
      overviewChartData: {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September'
        ],
        datasets: [
          {
            data: [50, 64, 32, 24, 18, 27, 20, 36, 30],
            borderColor: ['#009688'],
            backgroundColor: ['#80CBC4'],
            borderWidth: 2,
            fill: true,
            tension: 0.4
          }
        ]
      },
      overviewChartOptions: {
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            display: false
          },
          x: {
            display: false
          }
        },
        tooltips: {
          enabled: false
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    },
    {
      title: 'Clientes',
      icon: 'pi pi-fw pi-users',
      showPopUp: false,
      statistic_data: 8572,
      statistic_result: '2000 registrados',
      overviewChartData: {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September'
        ],
        datasets: [
          {
            data: [20, 29, 39, 36, 45, 24, 28, 20, 15],
            borderColor: ['#E91E63'],
            backgroundColor: ['#F48FB1'],
            borderWidth: 2,
            fill: true,
            tension: 0.4
          }
        ]
      },
      overviewChartOptions: {
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            display: false
          },
          x: {
            display: false
          }
        },
        tooltips: {
          enabled: false
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    },
    {
      title: 'Produtos',
      icon: 'pi pi-fw pi-box',
      showPopUp: false,
      statistic_data: 805,
      statistic_result: '405 vendidos',
      overviewChartData: {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September'
        ],
        datasets: [
          {
            data: [30, 39, 50, 21, 33, 18, 10, 24, 20],
            borderColor: ['#009688'],
            backgroundColor: ['#80CBC4'],
            borderWidth: 2,
            fill: true,
            tension: 0.4
          }
        ]
      },
      overviewChartOptions: {
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            display: false
          },
          x: {
            display: false
          }
        },
        tooltips: {
          enabled: false
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    }
  ] as DashboardData[];

  public showCardPerfil = false;
  public dadosEmpresa: IDomain = null;
  isNotSysadmin;

  public constructor(
    public dialog: MatDialog,
    public matSnackBar: MatSnackBar,
    public router: Router,
    protected domainService: DomainService,
    protected imagemService: ImagemService,
    protected tokenService: TokenService
  ) {
    const user = this.tokenService.getUser();
    this.isNotSysadmin =
      user.roles.findIndex(admin => admin.name.toUpperCase() === 'SYSADMIN') >=
      0;
  }

  /**
   * Baixa as informações de domain
   */
  protected verificarDadosEmpresa(): void {
    this.domainService
      .getEntity(this.tokenService.getDomain().id, 'application')
      .pipe(
        mergeMap(dadosEmpresa => {
          // caso tenha uma foto ela baixa
          if (dadosEmpresa.logo_id)
            return this.imagemService
              .donwloadImagem({
                imagemId: dadosEmpresa.logo_id,
                mapToBase64: true
              })
              .pipe(
                map(
                  (logo): IDomain => ({
                    ...dadosEmpresa,
                    logo_file: logo
                  })
                ),
                catchError((err: HttpErrorResponse) => throwError(() => err))
              );
          return of(dadosEmpresa);
        })
      )
      .subscribe(
        dadosempresa => {
          timer(1000).subscribe(() => {
            this.loading = false;
            this.showError = false;
          });
          if (
            !dadosempresa.contacts ||
            dadosempresa.contacts.length === 0 ||
            !dadosempresa.addresses ||
            dadosempresa.addresses.length === 0
          )
            this.dadosEmpresa = {} as IDomain;
          else {
            this.dadosEmpresa = dadosempresa;
            this.showCardPerfil = true;
          }
        },
        (err: HttpErrorResponse) => {
          this.loading = false;
          this.showError = true;
          this.displayError(err, true);
        }
      );
  }

  /**
   * @lifeCycle
   */
  public ngOnInit() {
    this.verificarDadosEmpresa();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;

    this.errorObj.message = txtMsg;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.dialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'pi pi-fw pi-info-circle text-orange-500 mb-2 mr-2',
            bodyMessage: txtMsg,
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.checkError();
  }
}
